import { type ComponentProps, type FC } from "react";
import { Icon } from "@root/shared/components/Icon";
import { Button } from "@root/shared/components/Button";
import { InformationText } from "@root/shared/components/InformationText";
import { ErrorInformationText } from "@userFrontend/components/ErrorInformationText";
import { SearchModal } from "@userFrontend/features/clientReview/components/ClientReviewInputs/uiParts/SearchModal";
import { ClientSelectInfoBox } from "@userFrontend/features/report/components/ClientSelectSection/uiParts/ClientSelectInfoBox";

// types
import {
  type Client,
  type ClientShop,
} from "@userFrontend/features/clientReview/components/ClientReviewInputs/type";
import { type ErrorText } from "@userFrontend/features/reward/components/ContinuedRewardInputs/type";
import * as styles from "./styles.css";

type Props = {
  isShowAnnotation?: boolean;
  client?: Client;
  clientShop?: ClientShop;
  handleShowModal: () => void;
  clientErrorText: ErrorText;
} & ComponentProps<typeof SearchModal>;

export const ClientSelect: FC<Props> = ({
  isShowAnnotation = true,
  client,
  clientShop,
  clientErrorText,
  handleShowModal,
  isShowSearchModal,
  handleCloseModal,
  clientNameValue,
  shopNameValue,
  clientNameErrorText,
  shopNameErrorText,
  handleClientSearch,
  handleChangeClientNameValue,
  handleChangeShopNameValue,
  searchResults,
  handleClientSelect,
  isShowClientsDetail,
  handleShowTextButton,
  tooManyResultErrorText,
  noResultError,
  displaySearchText,
  isSearching,
  handleReturnToMyPageTop,
  userContactPath,
}) => (
  <>
    {client?.clientName && client?.clientId ? (
      <>
        <ClientSelectInfoBox
          clientName={client?.clientName}
          clientShopName={clientShop?.shopName}
          onClick={handleShowModal}
        />
        {clientErrorText && <ErrorInformationText text={clientErrorText} />}
      </>
    ) : (
      <div className={styles.buttonWrapper}>
        <Button theme="primary" className={styles.button} onClick={handleShowModal}>
          選択する
        </Button>
        {clientErrorText && <ErrorInformationText text={clientErrorText} />}
      </div>
    )}
    <div className={styles.wrapper}>
      {isShowAnnotation && (
        <InformationText
          icon={<Icon name="information" />}
          text={<>リジョブに求人を掲載中の企業のみ、投稿を受け付けています。</>}
        />
      )}
    </div>
    <SearchModal
      isShowSearchModal={isShowSearchModal}
      handleCloseModal={handleCloseModal}
      clientNameValue={clientNameValue}
      shopNameValue={shopNameValue}
      clientNameErrorText={clientNameErrorText}
      shopNameErrorText={shopNameErrorText}
      handleClientSearch={handleClientSearch}
      handleChangeClientNameValue={handleChangeClientNameValue}
      handleChangeShopNameValue={handleChangeShopNameValue}
      searchResults={searchResults}
      handleClientSelect={handleClientSelect}
      isShowClientsDetail={isShowClientsDetail}
      handleShowTextButton={handleShowTextButton}
      tooManyResultErrorText={tooManyResultErrorText}
      noResultError={noResultError}
      displaySearchText={displaySearchText}
      isSearching={isSearching}
      handleReturnToMyPageTop={handleReturnToMyPageTop}
      userContactPath={userContactPath}
    />
  </>
);
